import { composeIO } from 'react-compose-io'
import { controleDebitosRecebiveisIO } from './ControleDebitosRecebiveis.IO'
import { ControleDebitosRecebiveisView } from './ControleDebitosRecebiveis.View'

export const ControleDebitosRecebiveis = composeIO(ControleDebitosRecebiveisView, controleDebitosRecebiveisIO)
